import { RangerFirearmAssignmentLogService } from './ranger-firearm-assignment-log.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { RANGER_FIREARM_ASSIGNMENT_LOG_TYPE, RangerFirearmAssignmentLog } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class RangerFirearmAssignmentLogResolverBase implements Resolve<RangerFirearmAssignmentLog> {

  constructor(protected service: RangerFirearmAssignmentLogService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RangerFirearmAssignmentLog> {
    const key: number = RANGER_FIREARM_ASSIGNMENT_LOG_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



